import { gql } from "@apollo/client"
import styled from "@emotion/styled"
import { Text, theme } from "@pallet-hq/hegel"
import { ListingInfo_listing } from "__generated__/ListingInfo_listing"

const PromptAnswerFragment = gql`
    fragment PromptAnswer_listingtype on ListingType {
        id
        promptAnswer
        applylist {
            id
            posterPrompt
        }
    }
`

type PromptAnswerProps = {
    listing: ListingInfo_listing
}

const PromptAnswer = (props: PromptAnswerProps) => {
    return (
        <PromptAnswerDiv>
            <PromptAnswerContentDiv>
                <QuestionDiv>
                    <Text variant="uiLarge600">
                        {props.listing.applylist.posterPrompt}
                    </Text>
                </QuestionDiv>
                <Text variant="paragraphLarge">
                    {props.listing.promptAnswer}
                </Text>
            </PromptAnswerContentDiv>
        </PromptAnswerDiv>
    )
}

PromptAnswer.fragment = PromptAnswerFragment

export default PromptAnswer

const PromptAnswerDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${theme.space.medium};
    background: ${theme.colors.gray100};
    border-radius: 8px;
    margin: ${theme.space.medium} 0;
`

const PromptAnswerContentDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
`

const QuestionDiv = styled.div`
    padding: ${theme.space.xxsmall} 0;
`
